import styled from "styled-components";

export const MainSection = styled.section`
  margin-top: 0rem;
  padding-bottom: 6rem;
  background-color: #032b88;

  .btn-div {
    margin-top: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const Title = styled.h5`
  font-size: 3.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
  text-align: center;
  padding-bottom: 5rem;
  color: #fff;
  padding-top: 6rem;
  @media (max-width: 990px) {
    text-align: center;
    font-size: 2.5rem;
  }
`;

export const Name = styled.h5`
  color: #fff;
  font-size: 1.25644rem;
  font-family: "Catamaran";
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: capitalize;

  @media (max-width: 990px) {
    text-align: start;
    font-size: 0.9rem;
  }
`;
export const Type = styled.h5`
  color: var(--white, #fff);
  font-size: 1.25644rem;
  font-family: "Catamaran";
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  text-transform: capitalize;

  @media (max-width: 990px) {
    text-align: start;
    font-size: 0.9rem;
  }
`;

export const DescriptionTitle = styled.h5`
  color: var(--white, #fff);
  font-size: 2.04994rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
  margin-top: 2rem;

  @media (max-width: 990px) {
    text-align: center;
  }
`;

export const Text = styled.p`
  color: var(--white, #fff);
  font-size: 1.15644rem;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  text-transform: capitalize;
  font-family: "Catamaran";
  margin-top: 1rem;
  @media (max-width: 990px) {
    text-align: center;
  }
`;

export const TimerDiv = styled.div`
  margin-top: 2rem;
  text-align: center;
  display: flex;
  justify-content: center;
  ._2EBbg {
    margin-bottom: 1rem !important;
  }
  ._106d2,
  ._SKh-V {
    background: #fff !important;
    color: #032b88 !important;
    border-bottom: none !important;
  }

  ._2v-d4 {
    background: #fff !important;
    color: #032b88 !important;
    border-bottom: none !important;
  }

  @media (max-width: 756px) {
    ._106d2,
    ._SKh-V {
      width: 2rem !important;
    }

    ._2v-d4 {
      width: 2rem !important;
    }

    ._3cpN7 {
      width: 4rem !important;
    }
  }
`;

export const BuyBtn = styled.button`
  --border: 5px;
  --slant: 0.7em;
  --color: #fff;
  font-family: "Catamaran";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0.2em 1.2em;
  border: none;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2rem;
  cursor: pointer;
  color: #032b88;
  background: linear-gradient(90.41deg, #fff 0.34%, #fff 99.15%);
  background-repeat: no-repeat;
  box-shadow: 0 0 0 200px inset var(--s, #0000),
    0 0 0 var(--border) inset var(--color);
  clip-path: polygon(
    0 0,
    calc(100% - var(--slant)) 0,
    100% var(--slant),
    100% 100%,
    var(--slant) 100%,
    0 calc(100% - var(--slant))
  );
  transition: color var(--t, 0.3s), background-size 0.3s;

  &:focus-visible {
    outline-offset: calc(-1 * var(--border));
    outline: var(--border) solid #000c;
    clip-path: none;
    background-size: 0 0;
  }

  @media (max-width: 990px) {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;
  }
`;

export const ImageWrapper = styled.div`
  text-align: center;
`;

export const TimerWrapper = styled.div`
  .whole-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 2rem;

    @media (max-width: 575.98px) {
      gap: 1rem;
      flex-wrap: wrap;
      justify-content: center;
    }
  }
`;

export const TimerSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  position: relative;

  .individual-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 5px;
  }

  .colon-tag {
    font-size: 24px;
    margin: 0;
    padding: 0;
    color: #fff;
    position: absolute;
    top: 10px;
    right: -20px;

    @media (max-width: 575.98px) {
      font-size: 18px;
      right: -10px;
    }
  }
`;

export const TimerBox = styled.div`
  width: 41.006px;
  height: 54.674px;
  border-radius: 7.29px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TimerText = styled.p`
  color: #032b88;
  text-align: center;
  font-size: 37.361px;
  font-style: normal;
  font-weight: 400;
  line-height: 26.882px; /* 71.951% */
  text-transform: capitalize;
  margin: 0;
  font-size: 42px;
`;

export const IndicatorText = styled.p`
  font-family: "Catamaran", sans-serif;
  color: #fff;
  text-align: center;
  font-size: 12.935px;
  font-style: normal;
  font-weight: 400;
  line-height: 26.882px; /* 245.833% */
  text-transform: capitalize;
`;
